import { Component } from '@angular/core';

/**
 * Access Denied page
 *
 * @export
 * @class AccessDeniedComponent
 */
@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    standalone: false
})
export class AccessDeniedComponent { }
